// Publishable/Public keys are safe to include in the frontend.
// Replace the placeholder below with your Paystack public key (starts with pk_test_ or pk_live_).
// Get it from: https://dashboard.paystack.com/#/settings/developers
export const PAYSTACK_PUBLIC_KEY =
  (import.meta.env.VITE_PAYSTACK_PUBLIC_KEY as string | undefined) ||
  'pk_live_8a4c486aa818a4bb95c24504316341f54e6c4e91';

export const isPaystackConfigured = () =>
  /^pk_(test|live)_/.test(PAYSTACK_PUBLIC_KEY) &&
  !PAYSTACK_PUBLIC_KEY.includes("REPLACE");

// PaystackPop is declared on Window elsewhere in the project (see C2CUpgrade.tsx).